<template>
  <div class="dashboard-card">
    <div class="card-header">
      <awesomeIcon icon="lock" style="width: 50px; height: 50px" /> Beveilig uw account
    </div>
    <div class="card-content" style="cursor:pointer;" @click="clickTwofactor()">
      <awesomeIcon icon="lock" style="width: 50px; height: 50px;"/>
      <h3>
        Wij bieden u graag de mogelijkheid om de tweestaps-verificatie aan te zetten.
        <br /><br />
        U ontvangt dan een extra code, via app of e-mail, om in te loggen in uw account.
      </h3>
      <p class="grey">
        Klik <u>hier</u> om uw tweestaps-verificatie in te stellen.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'twoFactorWidget',
  methods: {
    clickTwofactor() {
      this.$store.state.openTwofactor = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.card-content {
  color: $color-background;
  text-align: center;
  padding: 20px !important;
  .grey {
    cursor: pointer;
  }
}
</style>
